import { render, staticRenderFns } from "./IcmcapitalUnsuitableModal.vue?vue&type=template&id=d4072da8"
import script from "./IcmcapitalUnsuitableModal.vue?vue&type=script&lang=js"
export * from "./IcmcapitalUnsuitableModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports